"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeString = void 0;

var capitalizeString = function capitalizeString(str) {
  if (typeof str !== 'string') {
    return undefined;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

exports.capitalizeString = capitalizeString;